import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useReviewCreate } from '@/module/Author/Review/model/ReviewQuery';
import { ReviewSchema, defaultReviewValues, reviewSchema } from '@/module/Author/Review/model/ReviewSchema';

import { useAppNotification } from '@feature/utils';

import { ReviewForm } from './ReviewForm';

export function ReviewCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useReviewCreate();
  const navigate = useNavigate();
  const notification = useAppNotification();

  const onSubmit = (values: ReviewSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newReview => {
        notification.success();
        navigate({ to: '/author/review/$reviewId', params: { reviewId: String(newReview.id) } });
      },
    });
  };

  return (
    <ReviewForm
      title={t('reviews.form.title.create')}
      schema={reviewSchema}
      defaultValues={defaultReviewValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
      showWosFields={false}
      showScopusFields={false}
    />
  );
}
